import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-activity-data-step-sidebar {
  display: flex;
  flex-direction: column;
  gap: ${dt('appActivityDataStepSidebar.gap')};
  width: ${dt('appActivityDataStepSidebar.sidebarWidth')};
  flex-shrink: 0;
}

.app-activity-data-step-sidebar .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${dt('appActivityDataStepSidebar.itemTrailing.gap')};
  padding: ${dt('appActivityDataStepSidebar.item.padding')};
  min-height: ${dt('appActivityDataStepSidebar.item.minHeight')};
  box-sizing: border-box;
  background: ${dt('appActivityDataStepSidebar.item.background')};
  color: ${dt('appActivityDataStepSidebar.item.color')};
  font-family: ${dt('appActivityDataStepSidebar.item.fontFamily')};
  font-size: ${dt('appActivityDataStepSidebar.item.fontSize')};
  line-height: ${dt('appActivityDataStepSidebar.item.lineHeight')};
  font-weight: ${dt('appActivityDataStepSidebar.item.fontWeight')};
  text-align: left;
  cursor: pointer;
  width: 100%;
  border: none;
}

.app-activity-data-step-sidebar .item .item-label {
  flex: ${dt('appActivityDataStepSidebar.item.labelFlex')};
  min-width: 0;
}

.app-activity-data-step-sidebar .item.selected {
  background: ${dt('appActivityDataStepSidebar.itemSelected.background')};
  color: ${dt('appActivityDataStepSidebar.itemSelected.color')};
  border-left: 2px solid ${dt('appActivityDataStepSidebar.itemSelected.accentBorderColor')};
}

.app-activity-data-step-sidebar .item.selected .item-registration {
  color: ${dt('appActivityDataStepSidebar.itemSelected.registrationNumberColor')};
}

.app-activity-data-step-sidebar .item-trailing {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  align-self: center;
  gap: ${dt('appActivityDataStepSidebar.itemTrailing.gap')};
}

.app-activity-data-step-sidebar .item-registration {
  color: ${dt('appActivityDataStepSidebar.item.registrationNumberColor')};
}

.app-activity-data-step-sidebar .item-chevron {
  flex-shrink: 0;
  width: ${dt('appActivityDataStepSidebar.itemChevron.size')};
  height: ${dt('appActivityDataStepSidebar.itemChevron.size')};
  min-width: ${dt('appActivityDataStepSidebar.itemChevron.size')};
  min-height: ${dt('appActivityDataStepSidebar.itemChevron.size')};
  box-sizing: border-box;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  color: inherit;
}

.app-activity-data-step-sidebar .item-chevron-icon {
  font-size: ${dt('appActivityDataStepSidebar.itemChevron.iconFontSize')};
  line-height: 1;
  width: ${dt('appActivityDataStepSidebar.itemChevron.size')};
  height: ${dt('appActivityDataStepSidebar.itemChevron.size')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: ${dt('appActivityDataStepSidebar.itemChevron.borderWidth')} solid currentColor;
  border-radius: 9999px;
  box-sizing: border-box;
  transition: transform ${dt('transition.duration')} ease-out;
}

.app-activity-data-step-sidebar .item-chevron-icon-expanded {
  transform: rotate(90deg);
}

.app-activity-data-step-sidebar .item-confirmed-indicator {
  width: ${dt('appActivityDataStepSidebar.confirmedIndicator.size')};
  height: ${dt('appActivityDataStepSidebar.confirmedIndicator.size')};
  min-width: ${dt('appActivityDataStepSidebar.confirmedIndicator.size')};
  min-height: ${dt('appActivityDataStepSidebar.confirmedIndicator.size')};
  box-sizing: border-box;
  background: ${dt('appActivityDataStepSidebar.confirmedIndicator.background')};
  padding: ${dt('appActivityDataStepSidebar.confirmedIndicator.padding')};
  border-radius: ${dt('appActivityDataStepSidebar.confirmedIndicator.borderRadius')};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-activity-data-step-sidebar .item-confirmed-indicator .pi {
  color: ${dt('appActivityDataStepSidebar.confirmedIndicator.iconColor')};
  font-size: ${dt('appActivityDataStepSidebar.confirmedIndicator.iconSize')};
}

`;
